import { gql } from "@apollo/client";

// using email since employee ids can change if the HRMS changes
export const UPDATE_EMPLOYEE_ADMIN_STATUS = gql`
  mutation UpdateEmployeeAdminStatus($status: Boolean!, $emails: [String!]!) {
    updateEmployeeAdminStatus(status: $status, emails: $emails) {
      message
    }
  }
`;

export const UPDATE_EMPLOYEE_ROLES = gql`
  mutation UpdateEmployeeRoles($email: String!, $roleIds: [Int!]!) {
    updateEmployeeRoles(email: $email, roleIds: $roleIds) {
      message
    }
  }
`;
export const DELETE_EMPLOYEE_ROLES = gql`
  mutation DeleteEmployeeRoles($email: String!, $roleIds: [Int!]!) {
    deleteEmployeeRoles(email: $email, roleIds: $roleIds) {
      message
    }
  }
`;

export const GET_ROLE_ID_BY_DESCRIPTION = gql`
  query getRoleIdByDescription($role_description: String!) {
    getRoleIdByDescription(role_description: $role_description) {
      role_id
      framework_keys
    }
  }
`;

export const GET_ROLE_NAME_BY_DESCRIPTION = gql`
  query getRoleNameByDescription($role_description: String!) {
    getRoleNameByDescription(role_description: $role_description) {
      role_name
      framework_keys
    }
  }
`;
